export default {
  default: () => import("/home/forge/shop.ullmax.com/releases/20250811090653/layouts/default.vue").then(m => m.default || m)
}